module.exports = __webpack_public_path__ + "img/welcome.6ad8c98c.png";